import { useCallback } from 'react';
import { authService } from '../services/authService';
import { onboardingService } from '../services/onboardingService';
/**
 * Custom hook for managing onboarding progress
 * Automatically saves progress to backend after each step
 */
export const useOnboardingProgress = () => {
  /**
   * Save onboarding progress to backend
   * @param {string} userId - User ID
   * @param {Object} userData - User data object containing:
   *   - currentStep {number} - Current step number (0-6)
   *   - completed {boolean} - Whether onboarding is completed
   * @returns {Promise<Object>} - Onboarding progress response
   */
  const saveProgress = useCallback(async (userId, userData) => {
    try {
      //const { currentStep, completed = false } = userData;
      //const response = await authService.updateOnboardingStep(userId, userData);
      const response = await onboardingService.savePartialData(userData);
      //console.log(`✅ Onboarding progress saved: Step ${currentStep}${completed ? ' (Completed)' : ''}`);
      console.log(`✅ Onboarding progress saved: Step ${userData.currentStep}${userData.completed ? ' (Completed)' : ''}`);
      return response;
    } catch (error) {
      console.error('❌ Failed to save onboarding progress:', error);
      // Don't throw - let user continue even if save fails
      return null;
    }
  }, []);

  /**
   * Get onboarding progress from backend
   * @param {string} userId - User ID
   * @returns {Promise<Object>} - Onboarding progress response
   */
  const getProgress = useCallback(async (userId) => {
    try {
      const response = await onboardingService.getOnboardingStep(userId);
      return response;
    } catch (error) {
      console.error('Failed to get onboarding progress:', error);
      return null;
    }
  }, []);

  /**
   * Mark onboarding as completed
   * @param {string} userId - User ID
   * @returns {Promise<Object>} - Onboarding progress response
   */
  const markCompleted = useCallback(async (userId) => {
    return await onboardingService.markOnboardingCompleted(userId, { currentStep: 6, completed: true });
    //return await saveProgress(userId, { currentStep: 6, completed: true });
  }, [saveProgress]);

  return {
    saveProgress,
    getProgress,
    markCompleted
  };
};

export default useOnboardingProgress;